import { render, staticRenderFns } from "./PhrasesEditItem.vue?vue&type=template&id=0692fcce&scoped=true"
import script from "./PhrasesEditItem.vue?vue&type=script&lang=js"
export * from "./PhrasesEditItem.vue?vue&type=script&lang=js"
import style0 from "./PhrasesEditItem.vue?vue&type=style&index=0&id=0692fcce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0692fcce",
  null
  
)

export default component.exports